import { logger } from '@/utils/logger/logger';
import NoSleep from 'nosleep.js';

let noSleep: NoSleep | null = null;

export const enableNoSleep = async () => {
  if (!window || !window.WakeLock || !window.navigator.wakeLock) {
    return;
  }

  try {
    await navigator.wakeLock.request();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
  } catch (e) {
    logger.info('wakeLock not available.');
    return;
  }

  try {
    if (!noSleep) {
      noSleep = new NoSleep();
    }
    void noSleep.enable();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-explicit-any,unused-imports/no-unused-vars
  } catch (e: any) {
    logger.info('noSleep not available, error while enabling.');
  }
};

export const disableNoSleep = async () => {
  if (!window || !window.WakeLock || !window.navigator.wakeLock) {
    return;
  }

  try {
    await navigator.wakeLock.request();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
  } catch (e) {
    logger.info('wakeLock not available.');
    return;
  }

  try {
    if (!noSleep) {
      noSleep = new NoSleep();
    }
    void noSleep.disable();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-explicit-any,unused-imports/no-unused-vars
  } catch (e: any) {
    logger.info('noSleep not available, error while disabling.');
  }
};
